import createClient from "openapi-fetch";

import { authenticatedFetch } from "../lib/auth";
import type { paths } from "./e2eAgentSchema";

export const e2eAgentApi = createClient<paths>({
  baseUrl: "/api",
  fetch: authenticatedFetch,
});
